/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Field } from 'formik';
import { InputStyles } from './InputStyles';

const Select = props => {
  const { type, name, label, required = false, options, className, showAsterisk = true, placeholder = false, ...rest} = props;

  if (label) {
    return (
      <Field name={name}>
        {({ field, form, meta }) => {
          const hasError = form.submitCount > 0 && meta.touched && meta.error;
          return (
            <InputStyles className={['field-wrap select-field ', className].join(' ')}>
              <label htmlFor={name} className={field.value ? 'is-raised' : ''}>
                <span className="label-text">
                  {label} {showAsterisk && required && '*'}
                </span>
                <select
                  type={type}
                  id={name}
                  className={['field-control', hasError ? 'has-error' : null].join(' ')}
                  {...field}
                  {...rest}
                >
                  {placeholder && <option value="">{(field.value) ? placeholder : ''}</option> }
                  {options &&
                    options.map(item => (
                      <option value={item.value} key={item.label}>
                        {item.label}
                      </option>
                    ))}
                </select>
              </label>
            </InputStyles>
          );
        }}
      </Field>
    );
  }
};

export default Select;
